import { useContext } from 'react';
import { TranscriptDocumentContext } from '@/containers/Transcript/context';

export const useTranscriptDocumentContext = () => {
  return useContext(TranscriptDocumentContext);
};